// @ts-ignore
// import { API, Auth, graphqlOperation } from "aws-amplify";
import { env } from "@/env.mjs";
import * as userMutations from "../../graphql/mutations";
import * as userQueries from "../../graphql/queries";

const apiKey = "e";
//TODO SENTRY IMPORT COMMENTED
// import { //logError, logTrace } from "../sentryLogger";
import {
	CreateReviewMutation, CreateReviewMutationVariables,
	ActivateUserMutation,
	ActivateVideoMutation,
	ActivateVideoMutationVariables,
	BanUserMutation,
	CreateSubRecordMutation,
	CreateUserMutation,
	CreateUserProfileMutation,
	DecreaseVideoDislikesMutation,
	DecreaseVideoLikesMutation,
	DeleteUserMutation,
	DisableVideoMutation,
	EditSkillCategoryForUserMutation,
	EditSkillCategoryForUserMutationVariables,
	FindUserQuery,
	FlagVideoForDeletionMutation,
	FlagVideoForDeletionMutationVariables,
	GetAdminUsersQuery,
	GetAllPromotionalVideosQuery,
	GetAllPromotionalVideosQueryVariables,
	GetAllReportedVideosQuery,
	GetAllReportedVideosQueryVariables,
	GetAllTransactionsQuery,
	GetCountFromSpecificSkillCategoryAndDateRangeQuery,
	GetCountFromSpecificTierAndDateRangeQuery,
	GetDislikedVideoQuery,
	GetLikedVideoQuery,
	GetPaymentDueUsersQuery,
	GetPromotionalVideoQuery,
	GetPromotionalVideoQueryVariables,
	GetReportedUsersQuery,
	GetReportedVideoQuery,
	GetReportedVideoQueryVariables,
	GetReportedVideosByCategoryQuery,
	GetReportedVideosByCategoryQueryVariables,
	GetSkillCategoryQuery,
	GetSkillCategoryQueryVariables,
	GetTransactionsByDateQuery,
	GetUserIdByIdentityQuery,
	GetUserProfileQuery,
	GetUserSkillsQuery,
	GetUserTransactionsQuery,
	GetUserTransactionsQueryVariables,
	GetVideoPresignedUrlQuery,
	GetVideosByCategoryQuery,
	IncreaseVideoDislikesMutation,
	IncreaseVideoLikesMutation,
	IncrementWatchCounterMutation,
	IncrementWatchCounterMutationVariables,
	MakeUserAdminMutation,
	Platform,
	PublishUserSignUpEventMutationVariables,
	PutDeviceTokenMutationVariables,
	PutDeviceTokenResponse,
	ReplyToReviewMutation,
	ReportUserMutation,
	ReportVideoMutation,
	RevokeUserAdminMutation,
	SaveMeetingTransactionMutationVariables,
	SaveTransactionMutation,
	SaveUserIdentityMutation,
	SaveVideoMutation,
	SaveVideoMutationVariables,
	SearchQuery,
	SearchQueryVariables,
	SendReviewEmailMutation,
	SendReviewEmailMutationVariables,
	UpdateBusinessMutation,
	UpdateBusinessMutationVariables,
	UpdateFeaturedRecordMutation,
	UpdateMembershipTierMutation,
	UpdateMembershipTierMutationVariables,
	UpdateProfilePicMutation,
	UpdateProfilePicMutationVariables,
	UpdateSkillCategoryAboutMutation,
	UpdateSkillCategoryAboutMutationVariables,
	UpdateSkillCategoryAwardMutation,
	UpdateSkillCategoryAwardMutationVariables,
	UpdateSkillCategoryCertificationMutation,
	UpdateSkillCategoryCertificationMutationVariables,
	UpdateSkillCategoryEducationMutation,
	UpdateSkillCategoryEducationMutationVariables,
	UpdateSkillCategoryTagsMutation,
	UpdateSkillCategoryTagsMutationVariables,
	UpdateSubRecordMutation,
	UpdateUserInMeetingMutation,
	UpdateUserInMeetingMutationVariables,
	UpdateUserInfoMutation,
	UpdateUserInfoMutationVariables,
	UpdateUserLastSeenMutation,
	UpdateUserLastSeenMutationVariables,
	UpdateUserNameMutation,
	UpdateUserNameMutationVariables,
	UpdateUserStatusMutation,
	UpdateUserStatusMutationVariables,
	GetUserProfileQueryVariables,
	GetUserIdByIdentityQueryVariables,
	GetThumbnailSignedUrlQueryVariables,
	GetThumbnailSignedUrlQuery,
	GetUserMeetingsQueryVariables,
	GetUserMeetingsQuery,
	SignedUrlResult,
	UpdateFeaturedRecordMutationVariables,
	PublishUserSignUpEventMutation,
	CompleteUserProfileMutationVariables,
	CompleteUserProfileMutation,
	DeleteSkillCategoryMutationVariables,
	DeleteSkillCategoryMutation,
} from "@/graphql/API";
import { getServerSession } from "next-auth";
import { getSession } from "next-auth/react";
import { UserStatus } from "@/models/user-status";



async function getUser() {
	let session;

	if (typeof window === "undefined") {
		// We are on the server
		session = await getServerSession();
	} else {
		// We are on the client
		session = await getSession();
	}

	const user = session?.user;

	if (!user) {
		throw new Error("No user found in session");
	}

	const { id, email, name } = user;

	if (!name || name.trim() === "") {
		throw new Error("Invalid user name");
	}

	const nameParts = name.split(" ");

	const given_name = nameParts[0];
	const family_name = nameParts.slice(1).join(" ");

	const attributes = {
		sub: id,
		email: email,
		given_name,
		family_name,
		name,
	};

	return { ...user, attributes: attributes };
}

export async function initiateProfile(
	tierType: string,
	subscriptionId?: string
) {
	try {
		const user = await getUser();
		const { sub, email, given_name, family_name } = user.attributes;

		if (await getUserTier(sub)) {
			updateMembership(sub, tierType, subscriptionId);
		} else {
			let country = await retrieveLocationInfo();
			const date = new Date().toISOString().substring(0, 10);

			let results = await fetch(env.GRAPHQL_URL, {
				method: 'POST',
				headers: {
					"x-api-key": env.API_KEY,
					"Content-Type": "application/json"
				},

				body: JSON.stringify({
					query: userMutations.createUserProfile,
					variables: {
						profile: {
							email: email,
							userId: sub,
							firstName: given_name,
							lastName: family_name,
							status: UserStatus.ACTIVE,
							createdAt: date,
							tier: { startDate: date, type: tierType },
							subscription: subscriptionId,
							country: country,
						},
					}
				})
			});

			let response: { data: CreateUserProfileMutation } = await results.json();
			return response.data.createUserProfile;
		}
	}

	catch (error) {
		console.error('CreateUserProfile GQL Error', error as Error);
	}

}

async function retrieveLocationInfo() {
	const res = await fetch("https://geolocation-db.com/json/");
	const resJson = await res.json();
	console.log(resJson)

	return resJson.country_name;
}

export async function updateUsername(userId: string,firstName: string, lastName: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.updateUserName,
				variables: {
					userId,
					firstName,
					lastName
				} as UpdateUserNameMutationVariables
			})
		});
		let response: { data: UpdateUserNameMutation } = await results.json();
		return response.data.updateUserName;
	} catch (error) {
		console.error("UpdateUserName GQL Error", error as Error);
	}
}

export async function updateBusiness(userId: string, business: any) {
	console.log('update Business', business);
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.updateBusiness,
				variables: {
					userId,
					business
				} as UpdateBusinessMutationVariables
			})
		});

		let response: { data: UpdateBusinessMutation } = await results.json();
		console.log('result', response)
		return response.data.updateBusiness;
	} catch (error) {
		console.error("UpdateBusiness GQL Error", error as Error);
	}
}

export async function initiateSkillCategory(
	userId: string,
	skillName: string,
	skillId?: string,
	country?: string
) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.editSkillCategoryForUser,
				variables: {
					userId,
					skillName,
					skillId,
					country
				} as EditSkillCategoryForUserMutationVariables
			})
		});
		let response: { data: EditSkillCategoryForUserMutation } = await results.json();
		return response.data.editSkillCategoryForUser
	} catch (error) {
		console.error("InitiateSkillCategory GQL Error", error as Error);
	}
}

export async function updateSkillCategoryEducation(
	userId: string,
	skillId: string,
	education: any
) {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.updateSkillCategoryEducation,
				variables: {
					userId,
					skillId,
					education
				} as UpdateSkillCategoryEducationMutationVariables
			})
		});

		let response: { data: UpdateSkillCategoryEducationMutation } = await results.json();
		return response.data.updateSkillCategoryEducation

	} catch (error) {
		console.error("UpdateSkillCategoryEducation GQL Error", error as Error);
	}
}

export async function updateSkillCategoryCertification(
	userId: string,
	skillId: string,
	certification: any
) {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.updateSkillCategoryCertification,
				variables: {
					userId,
					skillId,
					certifications: certification
				} as UpdateSkillCategoryCertificationMutationVariables
			})
		});

		let response: { data: UpdateSkillCategoryCertificationMutation } = await results.json();
		return response.data.updateSkillCategoryCertification
	} catch (error) {
		console.error(
			"UpdateSkillCategoryCertification GQL Error",
			error as Error
		);
	}
}

export async function updateSkillCategoryAwards(
	userId: string,
	skillId: string,
	awards: any
) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.updateSkillCategoryAward,
				variables: {
					userId,
					skillId,
					awards
				} as UpdateSkillCategoryAwardMutationVariables
			})
		});

		let response: { data: UpdateSkillCategoryAwardMutation } = await results.json()
		return response.data.updateSkillCategoryAward
	} catch (error) {
		console.error("UpdateSkillCategoryAward GQL Error", error as Error);
	}
}

export async function updateSkillCategoryAbout(
	userId: string,
	skillId: string,
	about: any
) {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.updateSkillCategoryAbout,
				variables: {
					userId,
					skillId,
					about
				} as UpdateSkillCategoryAboutMutationVariables
			})
		});

		let response: { data: UpdateSkillCategoryAboutMutation } = await results.json();
		return response.data.updateSkillCategoryAbout;

	} catch (error) {
		console.error("UpdateSkillCategoryAbout GQL Error", error as Error);
	}
}

export async function updateSkillCategoryTags(
	userId: string,
	skillId: string,
	tags: any
) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.updateSkillCategoryTags,
				variables: {
					userId,
					skillId,
					tags
				} as UpdateSkillCategoryTagsMutationVariables
			})
		});
		let response: { data: UpdateSkillCategoryTagsMutation } = await results.json();
		return response.data.updateSkillCategoryTags
	} catch (error) {
		console.error("UpdateSkillCategoryTags GQL Error", error as Error);
	}
}

export async function saveVideo(video: any) {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.saveVideo,
				variables: {
					video
				} as SaveVideoMutationVariables
			})
		});

		let response: { data: SaveVideoMutation } = await results.json();
		return response.data.saveVideo
	} catch (error) {
		console.error("SaveVideo GQL Error", error as Error);
	}
}

export async function getVideo(videoId: string, preview: Boolean = false, userId?: string | undefined) {
	try {
		const result =
			preview
				?
				await fetch(env.GRAPHQL_URL, {
					method: 'POST',
					headers: {
						"x-api-key": env.API_KEY,
						"Content-Type": "application/json"
					},

					body: JSON.stringify({
						query: userQueries.getPromoVideoPreview,
						variables: {
							videoId
						} as GetPromotionalVideoQueryVariables
					})
				})
				:

				await fetch(env.GRAPHQL_URL, {
					method: 'POST',
					headers: {
						"x-api-key": env.API_KEY,
						"Content-Type": "application/json"
					},

					body: JSON.stringify({
						query: userQueries.getPromoVideo,
						variables: {
							videoId,
							userId
						} as GetPromotionalVideoQueryVariables
					})
				})
			;

		let response: { data: GetPromotionalVideoQuery } = await result.json();
		return response.data.getPromotionalVideo
	} catch (error) {
		console.error("GetVideo GQL Error", error as Error);
	}
}

export async function getVideoInfo(videoId: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userQueries.getPromoVideoInfo,
				variables: {
					videoId
				} as GetPromotionalVideoQueryVariables
			})
		});

		let response: { data: GetPromotionalVideoQuery } = await results.json();

		return response.data.getPromotionalVideo;
	} catch (error) {
		console.error("GetVideoInfo GQL Error", error as Error);
	}
}

export async function publishUserSignUpEvent(userId: string, username: string) {

	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.publishUserSignUpEvent,
				variables: {
					userId,
					username
				} as PublishUserSignUpEventMutationVariables
			})
		});

		let response: { data: PublishUserSignUpEventMutation } = await results.json()
		return response.data.publishUserSignUpEvent
	}
	catch (error) {
		console.error('PublishUserSignUpEventMutation GQL Error', error as Error);
	}

}

export async function saveTransaction(
	subID: string,
	subType: string,
	userId: string
) {
	var res = await fetch(env.GRAPHQL_URL, {
		method: "POST",
		headers: {
			"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
		},
		body: JSON.stringify({
			query: userMutations.saveTransaction,
			variables: { subID: subID, subType: subType, userId: userId },
		}),
	});
	const response = await res.json();
	return response;
}

export async function saveMeetingTransaction(orderID: string, userId: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.saveMeetingTransaction,
				variables: {
					orderID, userId
				} as SaveMeetingTransactionMutationVariables
			})
		});


		console.log('Save Meeting Transaction', results.json());
	} catch (error) {
		console.error("Failed to save meeting transaction", error as Error);
	}
}

export async function getTransactionsByDate() {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userQueries.getTransactionsByDate,
			})
		});
		let response: { data: GetTransactionsByDateQuery } = await results.json();
		return response.data.getTransactionsByDate
	} catch (error) {
		console.error("GetTransactionsByDate GQL Error", error as Error);
	}
}

export async function getAllTransactions() {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userQueries.getAllTransactions,
			})
		});

		let response: { data: GetAllTransactionsQuery } = await results.json();
		return response.data.getAllTransactions;
	} catch (error) {
		console.error("GetAllTransactions GQL Error", error as Error);
	}
}

export async function getUserTransactions(userId: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userQueries.getUserTransactions,
				variables: {
					userId
				} as GetUserTransactionsQueryVariables
			})
		});

		let response: { data: GetUserTransactionsQuery } = await results.json();
		return response.data.getUserTransactions
	} catch (error) {
		console.error("GetUserTransactions GQL Error", error as Error);
	}
}


export async function getUserVideos(userId: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userQueries.getUserPromoVideos,
				variables: {
					userId
				} as GetAllPromotionalVideosQueryVariables
			})
		});

		let response: { data: GetAllPromotionalVideosQuery } = await results.json();

		return response.data.getAllPromotionalVideos;
	} catch (error) {
		console.error("GetUserVideos GQL Error", error as Error);
	}
}


export async function getProfile(userId: string, area?: String) {
	try {
		let result;
		let res;
		switch (area) {
			case "business":
				// result = await API.graphql({
				// 	query: userQueries.getBusiness,
				// 	variables: { userId },
				// 	authMode: "AWS_IAM",
				// });
				res = await fetch(env.GRAPHQL_URL, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"x-api-key": env.API_KEY,
					},
					body: JSON.stringify({
						query: userQueries.getBusiness,
						variables: { userId } satisfies GetUserProfileQueryVariables,
					}),
				});

				break;
			case "about":
				// result = await API.graphql({
				// 	query: userQueries.getAbout,
				// 	variables: { userId },
				// 	authMode: "AWS_IAM",
				// });
				res = await fetch(env.GRAPHQL_URL, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"x-api-key": env.API_KEY,
					},
					body: JSON.stringify({
						query: userQueries.getAbout,
						variables: { userId } satisfies GetUserProfileQueryVariables,
					}),
				});

				break;
			case "education":
				// result = await API.graphql({
				// 	query: userQueries.getEducation,
				// 	variables: { userId },
				// 	authMode: "AWS_IAM",
				// });
				res = await fetch(env.GRAPHQL_URL, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"x-api-key": env.API_KEY,
					},
					body: JSON.stringify({
						query: userQueries.getEducation,
						variables: { userId } satisfies GetUserProfileQueryVariables,
					}),
				});

				break;
			case "certification":
				// result = await API.graphql({
				// 	query: userQueries.getCertification,
				// 	variables: { userId },
				// 	authMode: "AWS_IAM",
				// });
				res = await fetch(env.GRAPHQL_URL, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"x-api-key": env.API_KEY,
					},
					body: JSON.stringify({
						query: userQueries.getEducation,
						variables: { userId } satisfies GetUserProfileQueryVariables,
					}),
				});
				break;
			case "profile":
				// result = await API.graphql({
				// 	query: userQueries.getUserProfile,
				// 	variables: { userId },
				// 	authMode: "AWS_IAM",
				// });
				res = await fetch(env.GRAPHQL_URL, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"x-api-key": env.API_KEY,
					},
					body: JSON.stringify({
						query: userQueries.getUserProfile,
						variables: { userId } satisfies GetUserProfileQueryVariables,
					}),
				});
				break;
			case "status":
				// result = await API.graphql({
				// 	query: userQueries.getUserStatus,
				// 	variables: { userId },
				// 	authMode: "AWS_IAM",
				// });
				res = await fetch(env.GRAPHQL_URL, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"x-api-key": env.API_KEY,
					},
					body: JSON.stringify({
						query: userQueries.getUserStatus,
						variables: { userId } satisfies GetUserProfileQueryVariables,
					}),
				});
				break;
			case "inMeeting":
				// result = await API.graphql({
				// 	query: userQueries.getUserInMeetingStatus,
				// 	variables: { userId },
				// 	authMode: "AWS_IAM",
				// });
				res = await fetch(env.GRAPHQL_URL, {
					method: "POST",
					headers: {
						"x-api-key": env.API_KEY,
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: userQueries.getEducation,
						variables: { userId } satisfies GetUserProfileQueryVariables,
					}),
				});
				break;
		}
		result = (await res!.json()) as { data: GetUserProfileQuery };
		return result.data.getUserProfile;
	} catch (error) {
		console.error("GetProfile GQL Error", error as Error);
	}
}



export async function getUserSkills(userId: string) {
	try {
		let result;
		result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getUserSkills,
				variables: { userId },
			}),
		});

		let response: { data: GetUserSkillsQuery } = await result.json()

		return response.data.getUserSkills;
	} catch (error) {
		console.error("GetUserSkills GQL Error", error as Error);
	}
}



export async function getUserSkillSummary(userId: string) {
	try {
		let result;
		result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getUserSkillSummary,
				variables: { userId },
			}),
		});
		let response: { data: GetUserSkillsQuery } = await result.json()

		return response.data.getUserSkills;
	} catch (error) {
		console.error("GetUserSkillSummary GQL Error", error as Error);
	}
}

export async function getUserTier(userId: string) {
	try {
		let result;
		result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getUserTier,
				variables: { userId },
			}),
		});

		let response: { data: GetUserProfileQuery } = await result.json()
		return response.data.getUserProfile;
	} catch (error) {
		console.error("GetUserTier GQL Error", error as Error);
	}
}

export async function updateUserStatus(userId: string, status: string) {
	try {
		const result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.updateUserStatus,
				variables: { userId, status } as UpdateUserStatusMutationVariables,
			}),
		});

		let response: { data: UpdateUserStatusMutation } = await result.json()
		return response.data.updateUserStatus;
	} catch (error) {
		console.error("UpdateUserStatus GQL Error", error as Error);
	}
}

export async function updateMembership(
	userId: string,
	tierType: string,
	subscription?: string,
	trial: boolean = false

) {
	try {
		const date = new Date().toISOString().substring(0, 10);
		const result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.updateMembershipTier,
				variables: { userId, tier: { startDate: date, type: tierType }, subscriptionId: subscription, trial } as UpdateMembershipTierMutationVariables,
			}),
		});

		let response: { data: UpdateMembershipTierMutation } = await result.json();

		await updateUserInfo(userId, { date: date, type: tierType })

		return response.data.updateMembershipTier;
	} catch (error) {
		console.error("UpdateMembership GQL Error", error as Error);
	}
}

export async function updateUserInfo(
	userId: string,
	tier: any,
	country?: string
) {
	try {
		let location;

		if (!country) {
			location = await retrieveLocationInfo();
		} else {
			location = country
		}
		const result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.updateUserInfo,
				variables: {
					userId,
					tier: { startDate: tier.date, type: tier.type },
					country: location,
				} as UpdateUserInfoMutationVariables,
			}),
		});
		let response: { data: UpdateUserInfoMutation } = await result.json();
		return response.data.updateUserInfo;
	} catch (error) {
		console.error("UpdateUserInfo GQL Error", error as Error);
	}
}

export async function getSkillCategory(skillId: string, userId: string) {
	try {
		const result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getSkillCategory,
				variables: { userId, skillId } as GetSkillCategoryQueryVariables,
			}),
		});
		let response: { data: GetSkillCategoryQuery } = await result.json()
		return response.data.getSkillCategory;
	} catch (error) {
		console.error("GetSkillCategory GQL Error", error as Error);
	}
}

export async function getAllReportedVideos(lastKey: any) {
	try {
		const result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getAllReportedVideos,
				variables: { lastKey } as GetAllReportedVideosQueryVariables,
			}),
		});

		let response: { data: GetAllReportedVideosQuery } = await result.json()
		return response.data.getAllReportedVideos;
	} catch (error) {
		console.error("GetAllReportedVideos GQL Error", error as Error);
	}
}

export async function getReportedVideo(id: string) {
	try {
		const results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getReportedVideo,
				variables: { id } as GetReportedVideoQueryVariables,
			}),
		});

		let response: { data: GetReportedVideoQuery } = await results.json()

		return response.data.getReportedVideo;
	} catch (error) {
		console.error("GetReportedVideo GQL Error", error as Error);
	}
}

export async function getReportedVideosByCategory(
	category: string,
	lastKey: any
) {
	try {
		const results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getReportedVideosByCategory,
				variables: {
					category,
					lastKey,
				} as GetReportedVideosByCategoryQueryVariables,
			}),
		});

		let response: { data: GetReportedVideosByCategoryQuery } = await results.json();
		return response.data.getReportedVideosByCategory;
	} catch (error) {
		console.error("GetReportedVideosByCategory GQL Error", error as Error);
	}
}

export async function flagVideoForDeletion(id: string, labels: string[]) {
	try {
		const results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.flagVideoForDeletion,
				variables: { id, labels } as FlagVideoForDeletionMutationVariables,
			}),
		});

		let response: { data: FlagVideoForDeletionMutation } = await results.json()

		return response.data.flagVideoForDeletion;
	} catch (error) {
		console.error("FlagVideoForDeletion GQL Error", error as Error);
	}
}

export async function activateVideo(id: string) {
	try {
		const results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.activateVideo,
				variables: { id } as ActivateVideoMutationVariables,
			}),
		});

		let response: { data: ActivateVideoMutation } = await results.json()
		return response.data.activateVideo;
	} catch (error) {
		console.error("ActivateVideo GQL Error", error as Error);
	}
}

export async function search(
	searchTerm: string,
	index: string,
	location?: string | null,
	next = 0

) {
	try {
		const response = await fetch(`${env.GRAPHQL_URL}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'x-api-key': env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.search,
				variables: { searchTerm, index, location, next }
			}),
		});
		const result = await response.json()
		console.log("Result", result)
		return result
	} catch (error) {
		console.log('search error: ', (error as Error).message);
		// logError('Search GQL Error', error as Error);
	}
}


export async function updateProfilePic(userId: string, location: string) {
	try {

		const result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.updateProfilePic,
				variables: {
					userId,
					picLocation: location,
				} as UpdateProfilePicMutationVariables,
			}),
		});

		let response: { data: UpdateProfilePicMutation } = await result.json();
		return response.data.updateProfilePic;
	} catch (error) {
		console.error("UpdateProfilePic GQL Error", error as Error);
	}
}


export async function incrementWatch(videoId: string) {
	try {
		let result;
		result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.incrementWatchCounter,
				variables: { videoId } as IncrementWatchCounterMutationVariables,
			}),
		});

		let response: { data: IncrementWatchCounterMutation } = await result.json();
		return response.data.incrementWatchCounter
	} catch (error) {
		console.error('IncrementWatch GQL Error', error as Error);
	}
}




export async function disableVideo(userId: string, videoId: string) {
	try {
		let result;
		result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.disableVideo,
				variables: { videoId, userId },
			})
		})

		let response: { data: DisableVideoMutation } = await result.json();
		return response.data.disableVideo
	} catch (error) {
		console.error("DisableVideo GQL Error", error as Error);
	}
}
export async function findUser(id: string) {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.findUser,
				variables: { id },
			})
		})

		let response: { data: FindUserQuery } = await results.json();


		return response.data.findUser;
	} catch (error) {
		console.error("FindUser GQL Error", error as Error);
	}
}

export async function getReportedUsers(lastKey: any) {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getReportedUsers,
				variables: { lastKey },
			})
		})

		let response: { data: GetReportedUsersQuery } = await results.json();
		console.log("data", response);

		return response.data.getReportedUsers;
	} catch (error) {
		console.error("GetReportedUsers GQL Error", error as Error);
	}
}

export async function getPaymentDueUsers(lastKey: any) {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getPaymentDueUsers,
				variables: { lastKey },
			})
		})

		let response: { data: GetPaymentDueUsersQuery } = await results.json();


		return response.data.getPaymentDueUsers;
	} catch (error) {
		console.error("GetPaymentDueUsers GQL Error", error as Error);
	}
}

export async function getAdminUsers() {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getAdminUsers,
			}),
		});

		let response: { data: GetAdminUsersQuery } = await results.json();
		return response.data.getAdminUsers;
	} catch (error) {
		console.error("GetAdminUsers GQL Error", error as Error);
	}
}

export async function makeUserAdmin(id: string) {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.makeUserAdmin,
				variables: { id },
			})
		})
		let response: { data: MakeUserAdminMutation } = await results.json();

		return response.data.makeUserAdmin;
	} catch (error) {
		console.error("MakeUserAdmin GQL Error", error as Error);
	}
}

export async function revokeUserAdmin(id: string) {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.revokeUserAdmin,
				variables: { id },
			})
		})
		let response: { data: RevokeUserAdminMutation } = await results.json();

		return response.data.revokeUserAdmin;
	} catch (error) {
		console.error("RevokeUserAdmin GQL Error", error as Error);
	}
}

export async function banUser(id: string) {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.banUser,
				variables: { id },
			})
		})
		let response: { data: BanUserMutation } = await results.json();

		return response.data.banUser;
	} catch (error) {
		console.error("BanUser GQL Error", error as Error);
	}
}

export async function deleteUser(id: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.deleteUser,
				variables: { id },
			})
		})
		let response: { data: DeleteUserMutation } = await results.json();

		return response.data.deleteUser;
	} catch (error) {
		console.error('deleteUser GQL Error', error as Error);
	}
}

export async function activateUser(id: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.activateUser,
				variables: { id },
			}),
		});

		let response: { data: ActivateUserMutation } = await results.json();

		return response.data.activateUser;
	} catch (error) {
		console.error("ActivateUser GQL Error", error as Error);
	}
}

export async function reportUser(id: string, reasonReported: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userMutations.reportUser,
				variables: { id, reasonReported },
			}),
		});

		let response: { data: ReportUserMutation } = await results.json();
		return response.data.reportUser;



	} catch (error) {
		console.error("ReportUser GQL Error", error as Error);
	}
}

export async function getCountFromSpecificTierAndDateRange(
	tierType: string,
	startDate: string,
	endDate: string,
	location?: string
) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getCountFromSpecificTierAndDateRange,
				variables: {
					tierType,
					startDate,
					endDate,
					location,
				},
			}),
		});



		let response: { data: GetCountFromSpecificTierAndDateRangeQuery } = await results.json();
		console.log(response)

		return response.data.getCountFromSpecificTierAndDateRange;
	} catch (error) {
		console.error(
			"GetCountFromSpecificTierAndDateRange GQL Error",
			error as Error
		);
	}
}

export async function getVideosByCategory(category: string, pageParam = 0) {
	try {
		let result;

		result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getVideoByCategory,
				variables: { category, next: pageParam },
			}),
		});

		let response: { data: GetVideosByCategoryQuery } = await result.json();
		return response.data.getVideosByCategory

	} catch (error) {
		console.error("GetVideosByCategory GQL Error", error as Error);
	}
}
export async function getCountFromSpecificSkillCategoryAndDateRange(
	skillName: string,
	startDate: string,
	endDate: string,
	location?: string
) {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getCountFromSpecificSkillCategoryAndDateRange,
				variables: {
					skillName,
					startDate,
					endDate,
					location,
				},
			}),
		});

		let response: { data: GetCountFromSpecificSkillCategoryAndDateRangeQuery } = await results.json();

		return response.data.getCountFromSpecificSkillCategoryAndDateRange;
	} catch (error) {
		console.error(
			"GetCountFromSpecificSkillCategoryAndDateRange GQL Error",
			error as Error
		);
	}
}


export async function getUserReviews(userId: string) {
	try {
		// const result = (await API.graphql({
		// 	query: userQueries.getUserReviews,
		// 	variables: { userId: userId },
		// 	authMode: "AWS_IAM",
		// })) as any;

		const res = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getUserReviews,
				variables: { userId },
			})
		})

		const result = await res.json();
		return result.data.getUserReviews;
	} catch (error) {
		//logError('GetUserReviews GQL Error', error as Error);
	}
}

export async function sendReviewEmail(reviewText: string, rating: number) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.sendReviewEmail,
				variables: {
					reviewText, rating
				} as SendReviewEmailMutationVariables
			})
		});

		let response: SendReviewEmailMutation = await results.json();
		return response.sendReviewEmail;

	} catch (error) {
		console.error("SendReviewEmail GQL ERROR", { error });
	}
}

export async function updateUserLastSeen(userId: string) {
	return true;
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.updateUserLastSeen,
				variables: {
					userId
				} as UpdateUserLastSeenMutationVariables
			})
		});

		let response: { data: UpdateUserLastSeenMutation } = await results.json();

		return response.data.updateUserLastSeen;
	} catch (error) {
		console.error("UpdateUserLastSeen GQL Error", error as Error);
	}
}

// export async function saveUserIdentity(userId: string, identityId: string){
// 	try {
// 		const result = (await API.graphql(
// 			graphqlOperation(userMutations.saveUserIdentity, { userId, identityId })
// 		)) as {data: SaveUserIdentityMutation};
// 		//logTrace('save user identity', result)
// 		return result.data.saveUserIdentity;
// 	} catch (error) {
// 		//logError('SaveUserIdentity GQL Error', error as Error);
// 	}
// }

// export async function getUserIdByIdentity(identityId: string){
// 	try {
// 		const result = (await API.graphql(
// 			graphqlOperation(userQueries.getUserIdByIdentity, { identityId })
// 		)) as {data: GetUserIdByIdentityQuery};
// 		return result.data.getUserIdByIdentity;
// 	} catch (error) {
// 		//logError('GetUserIdByIdentity GQL Error', error as Error);
// 	}
// }

export async function updateUserInMeeting(userId: string, inMeeting: boolean) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},


			body: JSON.stringify({
				query: userMutations.updateUserInMeeting,
				variables: {
					userId, inMeeting
				} as UpdateUserInMeetingMutationVariables
			})
		});

		let response: UpdateUserInMeetingMutation = await results.json();
		return response.updateUserInMeeting
	} catch (error) {
		console.error("UpdateUserInMeeting GQL Error", error as Error);
	}
}


export async function createUser(email: string, firstName: string, lastName: string, tier: string, country: string) {
	try {
		let result = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.createUser,
				variables: { email, firstName, lastName, tier, country }
			})
		});

		let response: { data: CreateUserMutation } = await result.json();
		return response.data.createUser

	} catch (error) {
		console.error('CreateUser GQL Error', error as Error);
	}
}

export async function getVideoPresignedUrl(userId: string, fileName: string) {
	try {


		let result = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userQueries.getVideoPresignedUrl,
				variables: { userId, fileName }
			})
		});

		let response: { data: GetVideoPresignedUrlQuery } = await result.json();
		return response.data.getVideoPresignedUrl;
	} catch (error) {
		console.error("GetVideoSignedUrl GQL Error", error as Error);
	}
}

export async function updateFeaturedRecords(userId: string, videoId: string, videoType: string) {
	try {
		let result = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.updateFeaturedRecord,
				variables: { userId, videoId, videoType } as UpdateFeaturedRecordMutationVariables
			})
		});

		let response: { data: UpdateFeaturedRecordMutation } = await result.json();
		return response.data.updateFeaturedRecord
	} catch (error) {
		//logError('UpdateFeaturedRecord GQL Error', error as Error);
	}
}

// export async function registerUserNotificationToken(userId: string, token: string) {
// 	try {
// 		let results = (await API.graphql(
// 			graphqlOperation(userMutations.registerUserNotificationToken, { userId, token })
// 		)) as any;

// 		return results.data.registerUserNotificationToken;
// 	} catch (error) {
// 		//logError('registerUserNotificationToken GQL Error', error as Error);
// 	}
// }

//Convert for WatchList page
export async function increaseVideoLikes(userId: string, videoId: string) {
	try {


		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.increaseVideoLikes,
				variables: { userId, videoId }
			})
		});

		let response: { data: IncreaseVideoLikesMutation } = await results.json()
		return response.data.increaseVideoLikes;
	} catch (error) {
		console.error("increaseVideoLikes GQL Error", error as Error);
	}
}


export async function increaseVideoDislikes(userId: string, videoId: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.increaseVideoDislikes,
				variables: { userId, videoId }
			})
		});

		let response: { data: IncreaseVideoDislikesMutation } = await results.json()
		return response.data.increaseVideoDislikes;
	} catch (error) {
		console.error("increaseVideoDislikes GQL Error", error as Error);
	}
}

// COnvert for WatchList Page
export async function decreaseVideoLikes(userId: string, videoId: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.decreaseVideoLikes,
				variables: { userId, videoId }
			})
		});

		let response: { data: DecreaseVideoLikesMutation } = await results.json()
		return response.data.decreaseVideoLikes;
	} catch (error) {
		console.error("decreaseVideoLikes GQL Error", error as Error);
	}
}


export async function decreaseVideoDislikes(userId: string, videoId: string) {
	try {


		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.decreaseVideoDislikes,
				variables: { userId, videoId }
			})
		});

		let response: { data: DecreaseVideoDislikesMutation } = await results.json()
		return response.data.decreaseVideoDislikes;
	} catch (error) {
		console.error("decreaseVideoDislikes GQL Error", error as Error);
	}
}


export async function getLikedVideo(userId: string, videoId: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userQueries.getLikedVideo,
				variables: { userId, videoId }
			})
		});

		let response: { data: GetLikedVideoQuery } = await results.json()
		return response.data.getLikedVideo;
	} catch (error) {
		console.error("getLikedVideo GQL Error", error as Error);
	}
}

export async function getDislikedVideo(userId: string, videoId: string) {
	try {


		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userQueries.getDislikedVideo,
				variables: { userId, videoId }
			})
		});

		let response: { data: GetDislikedVideoQuery } = await results.json()
		return response.data.getDislikedVideo;
	} catch (error) {
		console.error("getDislikedVideo GQL Error", error as Error);
	}
}


export async function reportVideo(videoId: string, reasons: any) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.reportVideo,
				variables: { videoId, reasons }
			})
		});

		let response: { data: ReportVideoMutation } = await results.json()
		return response.data.reportVideo;
	} catch (error) {
		console.error("reportVideo GQL Error", error as Error);
	}
}

export async function sendReviewReply(reviewId: string, reply: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.replyToReview,
				variables: { reviewId, reply }
			})
		});

		let response: { data: ReplyToReviewMutation } = await results.json()
		return response.data.replyToReview;
	} catch (error) {
		console.error("replyToReview GQL Error", error as Error);
	}
}

export async function createSubRecord(subID: string, userId: string) {
	console.log("sub record", subID, userId)

	var res = await fetch(env.GRAPHQL_URL, {
		method: "POST",
		headers: {
			"x-api-key": env.API_KEY,
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			query: userMutations.createSubRecord,
			variables: { subID, userId },
		}),
	});

	return res.json();
}

export async function createTrialSubRecord(subID: string, userId: string) {
	console.log("trial sub record", subID, userId)

	var res = await fetch(env.GRAPHQL_URL, {
		method: "POST",
		headers: {
			"x-api-key": env.API_KEY,
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			query: userMutations.createTrialSubRecord,
			variables: { subID, userId },
		}),
	});

	return res.json();
}

// export const updateUserDeviceToken = async (params: {
// 	userId: string;
// 	token: string;
// 	platform: "ios" | "android" | "windows" | "macos" | "web";
// }) => {
// 	const response = (await API.graphql(
// 		graphqlOperation(userMutations.putDeviceToken, {
// 			deviceToken: params.token,
// 			userId: params.userId,
// 			platform: params.platform as Platform,
// 		} satisfies PutDeviceTokenMutationVariables)
// 	)) as { data: { putDeviceToken: PutDeviceTokenResponse } };

// 	return response.data.putDeviceToken;
// };

export async function createReview(userId: string, review: any) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,

				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.createReview,
				variables: {
					userId, review
				} as CreateReviewMutationVariables
			})
		});

		let response: { data: CreateReviewMutation } = await results.json();
		return response.data.createReview

	} catch (error) {
		console.error("CreateReview GQL Error", error as Error);
	}
}



export async function getUserIdByIdentity(identityId: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"

			},

			body: JSON.stringify({
				query: userQueries.getUserIdByIdentity,
				variables: {
					identityId
				} as GetUserIdByIdentityQueryVariables
			})
		});

		let response: { data: GetUserIdByIdentityQuery } = await results.json();
		return response.data.getUserIdByIdentity;

	} catch (error) {
		console.error("GetUserIdByIdentity GQL Error", error as Error);
	}
}

export async function getUserSummary(id: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: `query GetUserSummary($userId: String!){
          getUserProfile(userId: $userId) {
              tier{
                type
              }
              firstName
              lastName
              email
              userId
              picLocation
              country
			  status
            }
          }`,
				variables: {
					userId: id
				} as GetUserProfileQueryVariables
			})
		});

		let response: { data: GetUserProfileQuery } = await results.json();
		return response.data.getUserProfile
	} catch (error) {
		console.error("GetUserSummary GQL Error", error as Error);
	}
}

export const updateUserDeviceToken = async (params: {
	userId: string;
	token: string;
	platform: "ios" | "android" | "windows" | "macos" | "web";
}) => {
	console.log('updateUserDeviceToken', params)
	let results = await fetch(env.GRAPHQL_URL, {
		method: 'POST',
		headers: {
			"x-api-key": env.API_KEY,
			"Content-Type": "application/json"

		},

		body: JSON.stringify({
			query: userMutations.putDeviceToken,
			variables: {
				userId: params.userId,
				deviceToken: params.token,
				platform: params.platform as Platform
			} satisfies PutDeviceTokenMutationVariables
		})
	});
	let response: { data: { putDeviceToken: PutDeviceTokenResponse } } = await results.json()
	console.log('Res', response)
	return response.data.putDeviceToken;
};

export async function completeUserProfile(params: CompleteUserProfileMutationVariables) {
	const results = await fetch(env.GRAPHQL_URL, {
		method: 'POST',
		headers: {
			"x-api-key": env.API_KEY,
		},
		body: JSON.stringify({
			query: userMutations.completeUserProfile,
			variables: {
				...params
			} satisfies CompleteUserProfileMutationVariables
		})
	});

	const response: { data: { completeUserProfile: CompleteUserProfileMutation } } = await results.json()
	console.log('Res', response);
	return response.data.completeUserProfile;
}

export async function uploadVideoThumbnail(key: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"

			},

			body: JSON.stringify({
				query: userQueries.getThumbnailSignedUrl,
				variables: {
					key
				} as GetThumbnailSignedUrlQueryVariables
			})
		});

		let response: { data: GetThumbnailSignedUrlQuery } = await results.json();
		return response.data.getThumbnailSignedUrl

	} catch (error) {
		console.error("UploadVideoThumbnail GQL Error", error as Error);
	}
}

export async function getUserMeetings(userId: string) {
	try {
		const result = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"

			},

			body: JSON.stringify({
				query: userQueries.getUserMeetings,
				variables: {
					userId
				} as GetUserMeetingsQueryVariables
			})
		})

		let response: { data: GetUserMeetingsQuery } = await result.json();
		return response.data.getUserMeetings;
	} catch (error) {
		console.error("Failed to get user meetings", error as Error);
	}
}

export async function getPictureSignedUrl(key: string) {
	console.log("getPictureSignedUrl called", "");
	let results = await fetch(env.GRAPHQL_URL, {
		method: "POST",
		headers: {
			"x-api-key": env.API_KEY,
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			query: userQueries.getPictureSignedUrl,
			variables: {
				key
			}
		}),
	});

	let response: { data: { getPictureSignedUrl: SignedUrlResult } } =
		await results.json();

	return response.data.getPictureSignedUrl
}

export async function isUserAdmin(id: string) {
	let results = await fetch(env.GRAPHQL_URL, {
		method: "POST",
		headers: {
			"x-api-key": env.API_KEY,
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			query: `query IsUserAdmin($userId: String!){
						isUserAdmin(userId: $userId)
					}`,
			variables: {
				userId: id
			}
		}),
	});

	let response =
		await results.json();

	console.log("Res", response)

	return response.data.isUserAdmin
}

export async function getAllActiveUsers() {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getAllActiveUsers,
			}),
		});

		let response = await results.json();
		console.log("es", response)
		return response.data.getAllActiveUsers;
	} catch (error) {
		console.error("GetAllActiveUsers GQL Error", error as Error);
	}
}

export async function getAllActiveVideos() {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getAllActiveVideos,
			}),
		});

		let response = await results.json();
		return response.data.getAllActiveVideos;
	} catch (error) {
		console.error("GetActiveVideos GQL Error", error as Error);
	}
}

export async function getActiveUsers(lastKey: any) {
	try {

		let results = await fetch(env.GRAPHQL_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-key": env.API_KEY,
			},
			body: JSON.stringify({
				query: userQueries.getActiveUsers,
				variables: { lastKey },
			})
		})

		let response = await results.json();
		console.log("Res", response);

		return response.data.getActiveUsers;
	} catch (error) {
		console.error("GetActiveUsers GQL Error", error as Error);
	}
}

export async function deleteSkillCategory(id: string) {
	try {
		let results = await fetch(env.GRAPHQL_URL, {
			method: 'POST',
			headers: {
				"x-api-key": env.API_KEY,
				"Content-Type": "application/json"
			},

			body: JSON.stringify({
				query: userMutations.deleteSkillCategory,
				variables: {
					id
				} as DeleteSkillCategoryMutationVariables
			})
		});

		let response: { data: DeleteSkillCategoryMutation } = await results.json();

		return response.data.deleteSkillCategory;
	} catch (error) {
		console.error("DeleteSkillCategory GQL Error", error as Error);
	}
}

